import { DialogConfirm } from '../elements/DialogConfirm';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormAddAppendixSchema } from 'utils/validate';
import { Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Checkbox } from '../elements/CheckBox';
import { InputText } from '../elements/InputText';
import { ButtonCustom, ButtonOutLine } from '../elements/ButtonCustom';
import { InputSelectInfinite } from '../elements/InputSelectInfinite';
import { InputSelectMultipleInfinite } from '../elements/InputSelectMultiInfinite';
import { Appendix } from 'types/report';
export type FormAddAppendix = {
  fileId?: string;
  fileIds?: string[];
  isSelectAll?: boolean;
  content?: string;
};
type ModalAddAppendixProps = {
  isOpen: boolean;
  onCloseModal: () => void;
  onCancel: () => void;
  onSubmit: (value: FormAddAppendix) => void;
  optionFile: { value: string; label: string }[];
  onClickLink?: () => void;
  handleFetchMore: () => void;
  hasMore: boolean;
  isCreate?: boolean;
  initValue?: Appendix | null;
};
export const ModalAddAppendix = ({
  isOpen,
  onCloseModal,
  optionFile,
  onClickLink,
  onCancel,
  onSubmit,
  handleFetchMore,
  hasMore,
  isCreate,
  initValue
}: ModalAddAppendixProps) => {
  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    reset,
    formState: { errors }
  } = useForm<FormAddAppendix>({
    resolver: yupResolver(FormAddAppendixSchema)
  });

  useEffect(() => {
    if (!isOpen) {
      reset({
        content: '',
        fileIds: [],
        isSelectAll: false,
        fileId: undefined
      });
    }
  }, [isOpen, reset]);

  useEffect(() => {
    if (!initValue) return;
    reset({
      content: initValue?.content || '',
      fileId: initValue?.documentId?.toString()
    });
  }, [initValue, reset]);
  return (
    <DialogConfirm maxWidth={760} textTitle={'Add Appendix'} isOpen={isOpen} onClose={onCloseModal}>
      <Stack width={'100%'} gap={2.5}>
        {!watch('content') && (
          <Stack
            width={'100%'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}>
            <Stack style={{ width: 325 }}>
              {!isCreate ? (
                <Controller
                  control={control}
                  render={({ field: { value } }) => (
                    <InputSelectInfinite
                      onClickOption={(value) => {
                        setValue('fileId', value);
                      }}
                      handleFetchMore={handleFetchMore}
                      hasMore={hasMore}
                      value={value}
                      placeholder={'Select a PDF'}
                      sx={{ padding: 0 }}
                      options={optionFile || []}
                    />
                  )}
                  name={'fileId'}
                />
              ) : (
                <Controller
                  control={control}
                  render={({ field: { value } }) => (
                    <InputSelectMultipleInfinite
                      onChangeInput={(selectedValues) => {
                        setValue('fileIds', selectedValues);
                      }}
                      handleFetchMore={handleFetchMore}
                      hasMore={hasMore}
                      listChooseSelect={value || []}
                      placeholder={'Select a PDF'}
                      sx={{ padding: 0 }}
                      options={optionFile || []}
                    />
                  )}
                  name={'fileIds'}
                />
              )}
            </Stack>
            {isCreate && (
              <Controller
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Checkbox value={!!value} onCheck={onChange} label={'Select All'} />
                )}
                name={`isSelectAll`}
              />
            )}
          </Stack>
        )}
        {!((watch('fileIds') || []).length >= 1) && !watch('isSelectAll') && !watch('fileId') && (
          <InputText
            inputError={errors.content?.message}
            placeholder={'Enter text or paste content here'}
            inputProps={{
              ...register('content'),
              rows: 6,
              style: {
                minHeight: '46px',
                height: '172px',
                alignItems: 'flex-start',
                textAlign: 'start',
                padding: 0
              },
              multiline: true
            }}
          />
        )}

        <Stack
          flexDirection={'row'}
          alignItems={'flex-end'}
          justifyContent={'space-between'}
          width={'100%'}>
          <Stack>
            {onClickLink && (
              <Typography
                onClick={onClickLink}
                style={{ cursor: 'pointer' }}
                fontSize={'15px'}
                fontWeight={900}
                color={'#226AAA'}>
                See All Appendices
              </Typography>
            )}
          </Stack>
          <Stack flexDirection={'row'} gap={2.5}>
            <ButtonOutLine label={'Cancel'} style={{ width: 166 }} onClick={onCancel} fullWidth />
            <ButtonCustom
              style={{ width: 166 }}
              onClick={handleSubmit((value) => {
                onSubmit(value);
              })}
              label={'Add'}
            />
          </Stack>
        </Stack>
      </Stack>
    </DialogConfirm>
  );
};
